"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeavyAtomCount = void 0;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the heavy atom count of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
function getHeavyAtomCount(data) {
    const heavyAtomCount = (0, getNumberProperties_1.getNumberProperties)(data, 'Heavy Atom Count');
    return heavyAtomCount;
}
exports.getHeavyAtomCount = getHeavyAtomCount;
//# sourceMappingURL=getHeavyAtomCount.js.map